import { ReactNode, MouseEventHandler, CSSProperties, forwardRef } from "react"

type TypographyAs = "p" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "span"

/**
 * @param as - 렌더링할 HTML 태그 (기본: p)
 * @param size - 폰트사이즈
 * @param lineHeight - 줄높이
 * @param className - 클래스명
 * @param children - 자식요소
 * @param dangerouslySetInnerHTML - HTML 문자열을 컴포넌트 내부에 직접 삽입
 * @param style - 스타일
 * @param onMouseEnter - 마우스 올렸을때 함수
 * @param onMouseLeave - 마우스 떼졌을때 함수
 * @param onClick - 클릭함수
 */
interface TypographyProps {
  as?: TypographyAs
  size?: number
  lineHeight?: number | "normal"
  className?: string
  children?: ReactNode
  style?: CSSProperties
  whitespace?: "pre-line" | "pre" | "normal" | "nowrap" | "pre-wrap"
  dangerouslySetInnerHTML?: { __html: string }
  onMouseEnter?: MouseEventHandler<HTMLElement>
  onMouseLeave?: MouseEventHandler<HTMLElement>
  onClick?: MouseEventHandler<HTMLElement>
}

const Typography = forwardRef<HTMLElement, TypographyProps>(
  ({ as: Component = "p", size = 16, lineHeight = "normal", className, children, dangerouslySetInnerHTML, style, onMouseEnter, onMouseLeave, onClick, whitespace = "pre-line" }, ref) => {
    return (
      <Component
        className={`fs whitespace-${whitespace} ${className}`}
        ref={ref as React.Ref<never>}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onClick={onClick}
        style={
          {
            "--fs": size,
            "--lh": lineHeight === "normal" ? "normal" : lineHeight,
            ...style,
          } as React.CSSProperties
        }
      >
        {dangerouslySetInnerHTML ? <span dangerouslySetInnerHTML={dangerouslySetInnerHTML} /> : children}
      </Component>
    )
  }
)

Typography.displayName = "Typography"

export default Typography
